import{createTheme as e}from"@mui/material/styles";import t from"./lightTheme.js";var m=e(t,{palette:{mode:"dark"}});export{m as default};